import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled, { withTheme } from 'styled-components'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import ScrollableTable from '../../components/exchange/ScrollableTable'
import Price from '../../components/exchange/Price'
import Amount from '../../components/exchange/Amount'
import LoadingShade from '../../components/common/LoadingShade'
import { setCurrentPrice, setAmount } from '../../redux/exchange/action'
import { withI18n } from '../../i18n/util'

const Wrapper = styled.div`
  min-width: 300px;
  position: relative;
  display: flex;
  padding: 10px;
  min-height: 134px;
  justify-content: space-between;
`

const OrderBookWrap = styled.div`
  width: 49%;
  table {
    /* width: auto; */
    tbody tr {
      height: 20px;
      line-height: 20px;
      padding: 13px 0;
      td {
        font-size: 14px;
        @media (max-width: 350px) {
          font-size: 12px;
        }
      }
    }
  }
`

class OrderbookMobile extends PureComponent {
  static propTypes = {
    orderBooks: PropTypes.object,
    latestPrice: PropTypes.number,
    pairs: PropTypes.array,
    userInfo: PropTypes.object,
    currentTrade: PropTypes.string,
    dispatch: PropTypes.func,
    match: PropTypes.object,
    formatI18nText: PropTypes.func,
    theme: PropTypes.object.isRequired,
  }

  static defaultProps = {
    orderBooks: null,
    latestPrice: 0,
    pairs: [],
    userInfo: {},
    currentTrade: '',
    dispatch: () => {},
    match: {},
    formatI18nText: () => {},
  }

  _setAmount = (price, amount, type) => {
    const { dispatch, userInfo, currentTrade, latestPrice } = this.props
    if (!currentTrade) return

    amount = parseFloat(amount)
    dispatch(setCurrentPrice(price))

    const baseAsset = currentTrade.split('_')[0]
    const quotaAsset = currentTrade.split('_')[1]
    const balances = userInfo.balances || []
    const quotaAssetBalance = balances.find(b => b.symbol && b.symbol === quotaAsset) || {
      free: 0,
      frozen: 0,
      locked: 0,
    }
    const baseAssetBalance = balances.find(b => b.symbol && b.symbol === baseAsset) || {
      free: 0,
      frozen: 0,
      locked: 0,
    }

    const amountObj = {}
    if (type === 'ask') {
      const maxBuyAmount = parseFloat(quotaAssetBalance.free) / latestPrice

      amountObj.buyAmount = maxBuyAmount > amount ? amount : maxBuyAmount
    } else {
      amountObj.sellAmount =
        parseFloat(baseAssetBalance.free) > amount ? amount : parseFloat(baseAssetBalance.free)
    }
    dispatch(setAmount(amountObj))
  }

  _buildAsksColum = () => {
    const { formatI18nText, theme } = this.props
    const columns = [
      {
        title: formatI18nText('exchange.amount'),
        dataIndex: 'amount',
        headerAlign: 'left',
        width: '50%',
        key: 'Amount',
        render: item => (
          <div>
            <Amount
              onClick={this._setAmount}
              value={item.amount}
              price={item.price}
              type={item.type}
            />
          </div>
        ),
      },
      {
        title: formatI18nText('exchange.price'),
        headerAlign: 'right',
        dataIndex: 'price',
        width: '50%',
        key: 'Price',
        render: item => (
          <Price
            value={item.price}
            canSetPrice={true}
            alignContent="flex-end"
            priceColor={item.type === 'ask' ? theme.down : theme.up}
          />
        ),
      },
    ]

    return columns
  }

  _buildBidsColum = () => {
    const { formatI18nText, theme } = this.props
    const columns = [
      {
        title: formatI18nText('exchange.price'),
        headerAlign: 'left',
        dataIndex: 'price',
        width: '50%',
        key: 'Price',
        render: item => (
          <Price
            value={item.price}
            canSetPrice={true}
            priceColor={item.type === 'ask' ? theme.down : theme.up}
          />
        ),
      },
      {
        title: formatI18nText('exchange.amount'),
        dataIndex: 'amount',
        headerAlign: 'right',
        width: '50%',
        key: 'Amount',
        render: item => (
          <div>
            <Amount
              onClick={this._setAmount}
              value={item.amount}
              price={item.price}
              textAlign="flex-end"
              type={item.type}
            />
          </div>
        ),
      },
    ]

    return columns
  }

  _buildAsks = () => {
    const { orderBooks } = this.props
    const result = []
    const latestBook = orderBooks || { asks: [] }
    latestBook.asks.forEach(ask => {
      result.push({
        price: ask[0],
        amount: ask[1],
        total: ask[0] * ask[1],
        type: 'ask',
      })
    })
    return result
  }

  _buildBids = () => {
    const { orderBooks } = this.props
    const result = []
    const latestBook = orderBooks || { bids: [] }
    latestBook.bids.forEach(bid => {
      result.push({
        price: bid[0],
        amount: bid[1],
        total: bid[0] * bid[1],
        type: 'bid',
      })
    })

    return result
  }

  _reverseArray = arr => {
    const newArr = []
    for (let i = arr.length - 1; i >= 0; i--) {
      newArr.push(arr[i])
    }
    return newArr
  }

  render() {
    const { orderBooks } = this.props
    const asks = this._buildAsks()
    const bids = this._buildBids()
    const asksColumns = this._buildAsksColum()
    const bidsColumns = this._buildBidsColum()

    return (
      <Wrapper>
        <OrderBookWrap>
          <ScrollableTable
            columns={asksColumns}
            dataSource={asks.slice(0, 6)}
            withShadow={true}
            shadowDataIndex="amount"
            shadowBg="rgba(234,0,112,0.1)"
          />
        </OrderBookWrap>
        <OrderBookWrap>
          <ScrollableTable
            columns={bidsColumns}
            dataSource={bids.slice(0, 6)}
            withShadow={true}
            shadowDataIndex="amount"
            shadowBg="rgba(0,192,135,0.1)"
          />
        </OrderBookWrap>
        {!orderBooks && <LoadingShade />}
      </Wrapper>
    )
  }
}

const mapStateToProps = ({
  exchange: { currentTrade },
  tradePairs: { pairs },
  orderBooks,
  tickers: { symbolTickers },
  account: { userInfo },
}) => {
  const symbolTicker = symbolTickers.find(s => s.symbol === currentTrade) || {}
  const latestPrice = parseFloat(symbolTicker.price)
  return {
    latestPrice,
    userInfo,
    currentTrade,
    orderBooks: orderBooks && orderBooks[currentTrade],
    pairs,
  }
}

export default withI18n(connect(mapStateToProps)(withRouter(withTheme(OrderbookMobile))))
